var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-waiver-page"},[_c('BackTitle',{attrs:{"confirm-click":""},on:{"click":_vm.goBack}},[_vm._v(" Create Waiver ")]),_c('WaiverForm',{attrs:{"value":_vm.waiver,"is-submitting":_vm.isSubmitting},on:{"submit":_vm.submit}}),_c('div',{staticClass:"create-waiver-page__fixed",attrs:{"data-v-step":"16"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }